import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 333 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 25C6 25 0 23 0 23V0h333v23s-10 2-14.5 2c-15 0-61-21-71.5-21-11 0-71.5 21-80.5 21-8.5 0-71-21-80-21-10 0-59 21-70.5 21"
    }, null, -1)
  ])))
}
export default { render: render }